import { init as findRegistryInit } from '../components/findRegistryModalComponent';

export const brandModalHashes = {
    '#find-registry': { init: findRegistryInit },
};
